import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EndpointFilterPipe } from './endpoint-filter';
import { EndpointFilterWithoutCompaniesPipe } from './endpoint-filter-without-companies';
import { SearchPipe } from './search';
import { SearchSelectPipe } from './search-select';
import { SelectSearchPipe } from './select-search';
import { TruncPipe } from './trunc';
import { GeoedgeFilterPipe } from './geoedge-filter';
import { SearchCompanySourcePipe } from './search-company-source';
import { TcfCompaniesSearchPipe } from './tcf-companies-search';

@NgModule({
  declarations: [
    EndpointFilterPipe,
    EndpointFilterWithoutCompaniesPipe,
    SearchPipe,
    SearchSelectPipe,
    SelectSearchPipe,
    TruncPipe,
    GeoedgeFilterPipe,
    SearchCompanySourcePipe,
    TcfCompaniesSearchPipe,
  ],
  exports: [
    EndpointFilterPipe,
    EndpointFilterWithoutCompaniesPipe,
    SearchPipe,
    SearchSelectPipe,
    SelectSearchPipe,
    TruncPipe,
    GeoedgeFilterPipe,
    SearchCompanySourcePipe,
    TcfCompaniesSearchPipe,
  ],
  imports: [
    CommonModule,
  ],
  providers: [
    EndpointFilterPipe,
    EndpointFilterWithoutCompaniesPipe,
    SearchPipe,
    SearchSelectPipe,
    SelectSearchPipe,
    TruncPipe,
    GeoedgeFilterPipe,
    SearchCompanySourcePipe,
    TcfCompaniesSearchPipe,
  ]
})
export class PipesModule { }
